import {
    addDoc,
    collection,
    deleteDoc,
    doc,
    getDocs,
    query,
    updateDoc,
    type Firestore,
    type QueryConstraint,
} from 'firebase/firestore';

export type TenantDocument<T> = T & { id: string };
export type TenantDocumentPayload = Record<string, unknown>;

export function tenantCollectionPath(tenantId: string, collectionName: string): string {
    return `tenants/${tenantId}/${collectionName}`;
}

export async function fetchTenantCollection<T>(
    db: Firestore,
    tenantId: string,
    collectionName: string,
    constraints: QueryConstraint[] = [],
): Promise<Array<TenantDocument<T>>> {
    const collectionRef = collection(db, tenantCollectionPath(tenantId, collectionName));
    const snapshot = await getDocs(constraints.length ? query(collectionRef, ...constraints) : collectionRef);

    return snapshot.docs.map((documentSnapshot) => ({
        ...(documentSnapshot.data() as T),
        id: documentSnapshot.id,
    }));
}

export async function createTenantDocument(
    db: Firestore,
    tenantId: string,
    collectionName: string,
    payload: TenantDocumentPayload,
): Promise<string> {
    const documentRef = await addDoc(collection(db, tenantCollectionPath(tenantId, collectionName)), payload);

    return documentRef.id;
}

export async function updateTenantDocument(
    db: Firestore,
    tenantId: string,
    collectionName: string,
    documentId: string,
    patch: TenantDocumentPayload,
): Promise<void> {
    await updateDoc(doc(db, tenantCollectionPath(tenantId, collectionName), documentId), patch);
}

export async function deleteTenantDocument(
    db: Firestore,
    tenantId: string,
    collectionName: string,
    documentId: string,
): Promise<void> {
    await deleteDoc(doc(db, tenantCollectionPath(tenantId, collectionName), documentId));
}
